import { AiOutlinePlus } from "react-icons/ai"; 
import React, {useState} from 'react';
import { BiTrash } from "react-icons/bi"; 
import { BiEditAlt } from "react-icons/bi"; 
import '../css/MembersTable.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { categories } from './../Data/categorie';
import CategorieForm from './../forms/CategorieForm';
import EditCategorieForm from './../forms/edits/EditCategorieForm';

function CategoriTable() {
    const [searchTerm, setSearchTerm] = useState("");
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage, setItemsPerPage] = useState(5);
      const [showModal, setShowModal] = useState(false);
      const [showEditModal, setShowEditModal] = useState(false);
      const [selectedCategorie, setSelectedCategorie] = useState({});
    
    
      const filteredData = categories.filter((categorie) => {
        return categorie.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
    
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    
      const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
      const handleAddNew = () => {
        setShowModal(true);
      };
    
      const handleCloseModal = () => {
        setShowModal(false);
      };
    
      const handleEditCategorie = (categorie) => {
        setSelectedCategorie(categorie);
        setShowEditModal(true);
      };
    
      const handleCloseEditModal = () => {
        setShowEditModal(false);
      };
    
      const handleUpdateCategorie = (updatedCategorie) => {
        const updatedList = categories.map((categorie) => {
          if (categorie.name === selectedCategorie.name) {
            return updatedCategorie;
          }
          return categorie;
        });
    
        setShowEditModal(false);
      };
    
      const handleDeleteCategorie = (categorie) => {
        if (window.confirm(`Voulez-vous vraiment supprimer la categorie ${categorie.name} ?`)) {
          
          toast.success(`La categorie ${categorie.name} a été supprimé avec succès !`);
        }
      };
  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-lg font-bold">Liste des categories</h1>
        <div className="flex gap-2">
          <button className="btn-primary" onClick={handleAddNew}><AiOutlinePlus /> Ajouter une categorie</button>
          <button className="btn-secondary">Export categories (Excel)</button>
          <input
            type="text"
            placeholder="Rechercher une catégorie..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar"
          />
        </div>
      </div>

      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">Nom de la categorie</th>
          </tr>
        </thead>
        <tbody>
        {currentItems.map((categorie, index) => (
            <tr key={index} className="text-center">
              <td className="border border-gray-300 px-4 py-2">{categorie.name}</td>
              <td className="border border-gray-300 px-4 py-2">
                <button className="text-blue-500 mx-1" onClick={() =>  handleEditCategorie(categorie)}><BiEditAlt /></button>
                <button className="text-red-500 mx-1" onClick={() => handleDeleteCategorie(categorie)}><BiTrash /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        {Array.from(
          { length: Math.ceil(filteredData.length / itemsPerPage) },
          (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          )
        )}
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <CategorieForm />
          </div>
        </div>
      )}


      {showEditModal && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseEditModal}>
              &times;
            </button>
            <EditCategorieForm categorie={selectedCategorie} handleUpdateCategorie={handleUpdateCategorie}/>
          </div>
        </div>
      )}
    </div>
  )
}

export default CategoriTable